/** Valores persistidos em `Entrega.shippingPeriod` (alinhado ao checkout / NewOrder). */
export const PERIODO_MANHA = 'Manhã 9h às 12h';
export const PERIODO_TARDE = 'Tarde 12h às 18h';
export const PERIODO_NOITE = 'Noite 18h às 21h';

export const PERIODOS_ENTREGA_FILTRO = [
	{ value: PERIODO_MANHA, label: 'Manhã' },
	{ value: PERIODO_TARDE, label: 'Tarde' },
	{ value: PERIODO_NOITE, label: 'Noite' },
];
